import MainLayout from "../../components/layout/MainLayout";
import SafeJobAnalysisTable from "./components/sja-table";

export default function SjaPage(){
  return (
    <MainLayout title={"SJA"}>
      <SafeJobAnalysisTable />
    </MainLayout>
  );
}
